// extracted by mini-css-extract-plugin
export default {"form":"ProfileDetailsForm_form__8hIVc","avatar":"ProfileDetailsForm_avatar__cLFG5","textarea":"ProfileDetailsForm_textarea__tf7RC","image":"ProfileDetailsForm_image__VXckh"};